import script from "./AudioRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioRecord.vue?vue&type=script&setup=true&lang=js"

import "./AudioRecord.vue?vue&type=style&index=0&id=2d7e9065&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7e9065"]])

export default __exports__